import { defineComponent as _defineComponent } from 'vue'
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import ApplicationTabContent from "./ApplicationTabContent.vue"
import {
  PendingMissionStaffingApplicationFragmentFragment,
  MissionStaffingApplicationsQuery,
  MissionStaffingApplicationsQueryQuery,
  TalentPoolQuery,
  TalentPoolQueryQuery,
  ConsultantTalentFragmentFragment,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { ref, computed } from "vue"
import Pagination from "@/components/widgets/common/Pagination.vue"
import ConfirmApplications from "@/modules/Missions/components/Details/ManageTeamRoles/StaffingPositionDetails/ConfirmApplications.vue"
import { ApplicationActions } from "./constant"
import ApplicantDetail from "@/views/talent/ApplicantDetail.vue"
import { useLazyQuery } from "@vue/apollo-composable"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantsApplications',
  props: {
    staffingPositionId: null
  },
  setup(__props: any) {

const props = __props as {
  staffingPositionId: string
}



const tabs = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Approved",
    value: "approved",
  },
  {
    label: "Declined",
    value: "declined",
  },
]

const onApplicationClick = (application: PendingMissionStaffingApplicationFragmentFragment) => {
  showProfileModal.value = true
  getApplicantDetail(application.consultant.id)
}

const applications = ref<PendingMissionStaffingApplicationFragmentFragment[]>([])

const pagination = ref({
  page: 1,
  per: 2,
  length: 1,
})

const queryOptions = computed(() => ({
  filter: {
    id: props.staffingPositionId,
  },
  per: pagination.value.per,
  page: pagination.value.page,
}))

const { loading, onResult } = useQuery<MissionStaffingApplicationsQueryQuery>(
  MissionStaffingApplicationsQuery,
  queryOptions
)

const refetchQueries = computed(() => {
  return [
    {
      query: MissionStaffingApplicationsQuery,
      variables: {
        ...queryOptions.value,
      },
    },
  ]
})

const groupApplicationsByState = computed(() => {
  return applications.value.reduce((acc, application) => {
    acc[application.state] = [...(acc[application.state] || []), application]
    return acc
  }, {} as Record<string, PendingMissionStaffingApplicationFragmentFragment[]>)
})

onResult(({ data }) => {
  applications.value = data?.missionStaffingPositions?.data?.[0]?.missionStaffingApplications || []
  pagination.value.length = data?.missionStaffingPositions?.pagination?.pageCount || 0
})

const confirmDialogText = ref({
  message: "",
  btnText: "",
})

const selectedApplication = ref<PendingMissionStaffingApplicationFragmentFragment | null>(null)
const selectedAction = ref<(typeof ApplicationActions)[keyof typeof ApplicationActions] | null>(
  null
)

const showConfirmDialog = ref(false)
const showProfileModal = ref(false)
const updateSelectedApplicationDetails = ({
  message,
  btnText,
  application,
  action,
}: {
  message: string
  btnText: string
  application: PendingMissionStaffingApplicationFragmentFragment
  action: (typeof ApplicationActions)[keyof typeof ApplicationActions]
}) => {
  confirmDialogText.value = {
    message,
    btnText,
  }
  selectedApplication.value = application
  selectedAction.value = action

  showConfirmDialog.value = true
}

const onCloseConfirmDialog = () => {
  showConfirmDialog.value = false
  selectedApplication.value = null
  selectedAction.value = null
}

const selectedApplicant = ref<ConsultantTalentFragmentFragment | null>(null)

const {
  load,
  loading: applicantLoading,
  onResult: onApplicantResult,
} = useLazyQuery<TalentPoolQueryQuery>(TalentPoolQuery)

const getApplicantDetail = (id: string) => {
  load(undefined, {
    filter: {
      idIn: [id],
    },
    per: 1,
    page: 1,
  })
}

onApplicantResult((result) => {
  if (!result.data?.talentPool.data[0]) return
  selectedApplicant.value = result.data?.talentPool.data[0]
})

return { __sfc: true,props, tabs, onApplicationClick, applications, pagination, queryOptions, loading, onResult, refetchQueries, groupApplicationsByState, confirmDialogText, selectedApplication, selectedAction, showConfirmDialog, showProfileModal, updateSelectedApplicationDetails, onCloseConfirmDialog, selectedApplicant, load, applicantLoading, onApplicantResult, getApplicantDetail, Tab, Tabs, ApplicationTabContent, Pagination, ConfirmApplications, ApplicantDetail, Header }
}

})